import { useMemo } from 'react';
import { useTheme } from '@mui/material/styles';
import {
  getDropzoneAcceptStyle,
  getDropzoneBaseStyle,
  getDropzoneFocusedStyle,
  getDropzoneMobileBaseStyle,
  getDropzoneRejectStyle,
} from './styles';

type DropzoneStyleState = {
  isFocused: boolean;
  isDragAccept: boolean;
  isDragReject: boolean;
  isMobile?: boolean;
};

export const useDropzoneStyles = ({
  isFocused,
  isDragAccept,
  isDragReject,
  isMobile = false,
}: DropzoneStyleState) => {
  const theme = useTheme();

  return useMemo(
    () => ({
      ...(isMobile ? getDropzoneMobileBaseStyle(theme) : getDropzoneBaseStyle(theme)),
      ...(isFocused ? getDropzoneFocusedStyle(theme) : {}),
      ...(isDragAccept ? getDropzoneAcceptStyle(theme) : {}),
      ...(isDragReject ? getDropzoneRejectStyle(theme) : {}),
    }),
    [isFocused, isDragAccept, isDragReject, isMobile, theme],
  );
};
